import React, { Dispatch, FC, ReactElement, SetStateAction, useCallback, useState } from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import { toIcons } from '../../consts/Paths';

interface CustomModalProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    title: string;
    description: string;
    ctaTtitle?: string;
    ctaFunction?: () => void;
    children?: ReactElement;
}

const CustomModal: FC<CustomModalProps> = ({ setShow, title, description, ctaTtitle, ctaFunction, children }) => {
    const { isMobile } = useIsMobile();
    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='logout-modal'
                style={{
                    width: isMobile ? '345px' : '900px',
                }}
            >
                <div className='logout-modal-content'>
                    <div className='modal-header'>
                        <div>
                            <p
                                className='modal-title'
                                style={{
                                    fontWeight: '600',
                                }}
                            >
                                {title && title}
                            </p>
                        </div>
                        <div className='Oval' onClick={() => setShow(false)}>
                            <img src={`${toIcons}/close.svg`} />
                        </div>
                    </div>
                    {description && (
                        <p
                            className='delete-title'
                            style={{
                                fontSize: isMobile ? '18px' : '',
                                fontWeight: '600',
                                width: isMobile ? '299px' : '400px',
                            }}
                        >
                            {description}
                        </p>
                    )}
                    {children && <>{children}</>}
                    {ctaTtitle && (
                        <div className='delete-cta-box' style={{ marginTop: '15px' }}>
                            <button className='delete-cta-button offLightBlueBG' onClick={ctaFunction}>
                                <p className='delete-cta-button-text whiteTXT'>{ctaTtitle}</p>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomModal;
